import React from "react";
import ellipseRed from "../assets/images/ellipse-red.svg";
import ellipseGreen from "../assets/images/ellipse-green.svg";
import ellipseBlue from "../assets/images/ellipse-blue.svg";
import cmpTicker from "../assets/images/cmpTicker.svg";


const SummarySlider = ({
  minValue,
  maxValue,
  startValue,
  endValue,
  currentPrice,
  status,
  isMobile,
  transactionType = "BUY",
}) => {
  
 
  const min = Math.min(parseFloat(minValue), parseFloat(maxValue));
  const max = Math.max(parseFloat(minValue), parseFloat(maxValue));
  
  
  const rawStart = Math.min(parseFloat(startValue), parseFloat(endValue));
  const rawEnd = Math.max(parseFloat(startValue), parseFloat(endValue));
  
  const start = Math.max(min, Math.min(max, rawStart));
  const end = Math.max(min, Math.min(max, rawEnd));
  
  const totalRange = max - min || 1; 
  
  const leftPercentage = Math.max(0, Math.min(100, ((start - min) / totalRange) * 100));
  const rightPercentage = Math.max(0, Math.min(100, ((max - end) / totalRange) * 100));
  
  const isLeftEntryNearEdge = leftPercentage < 5;
  const isRightEntryNearEdge = rightPercentage < 5;
  
  const adjustedLeftPercentage = isLeftEntryNearEdge ? Math.max(leftPercentage, 3) : leftPercentage;
  const adjustedRightPercentage = isRightEntryNearEdge ? Math.max(rightPercentage, 3) : rightPercentage;
  
  const centerPercentage =
    leftPercentage + (100 - leftPercentage - rightPercentage) / 2;
  const cmpPos = ((parseFloat(currentPrice) - min) / totalRange - 0.5) * 100;



  
  const entryIndicatorColor = ellipseBlue;

  const calculatePnLBar = () => {
    const entryMid = (start + end) / 2;
    const cmp = parseFloat(currentPrice);

    let barStart = entryMid;
    let barEnd = entryMid;
    let barColor = "#d9d9d9";

    
    if (status === "CLOSED_STOPLOSSHIT") {
      if (transactionType === "BUY") {
        barStart = min;
        barEnd = entryMid;
      } else {
        barStart = entryMid;
        barEnd = max;
      }
      barColor = "#E53935"; 
    }

    
    else if (status === "CLOSED_TARGETHIT") {
      if (transactionType === "BUY") {
        barStart = entryMid;
        barEnd = max;
      } else {
        barStart = min;
        barEnd = entryMid;
      }
      barColor = "#1E8C45"; 
    }

    
    else if (status?.includes("LIVE")) {
      const benchmark = cmp < start ? start : end;

      if (transactionType === "BUY") {
        if (cmp >= benchmark) {
          barStart = benchmark;
          barEnd = cmp;
          barColor = "#1E8C45"; 
        } else {
          barStart = cmp;
          barEnd = benchmark;
          barColor = "#E53935"; 
        }
      } else {
        if (cmp <= benchmark) {
          barStart = cmp;
          barEnd = benchmark;
          barColor = "#1E8C45"; 
        } else {
          barStart = benchmark;
          barEnd = cmp;
          barColor = "#E53935"; 
        }
      }
    }
    
   
    else {
      barStart = start;
      barEnd = end;
      barColor = "#1567A7";
    }

    
    barStart = Math.max(min, Math.min(max, barStart));
    barEnd = Math.max(min, Math.min(max, barEnd));

    const left = ((barStart - min) / totalRange) * 100;
    const right = ((max - barEnd) / totalRange) * 100;

    
    const clampedLeft = Math.max(0, Math.min(100, left));
    const clampedRight = Math.max(0, Math.min(100, right));

    return { leftPos: clampedLeft, rightPos: clampedRight, barColor };
  };

  const pnlBar = calculatePnLBar();

  const cmpLeftPos = ((parseFloat(currentPrice) - min) / totalRange) * 100;
  const constrainedCmpLeft = Math.max(0, Math.min(100, cmpLeftPos));

  const isBuy = transactionType === "BUY";
  const leftLabel = isBuy ? "Stop Loss" : "Target";
  const rightLabel = isBuy ? "Target" : "Stop Loss";
  const leftIcon = isBuy ? ellipseRed : ellipseGreen;
  const rightIcon = isBuy ? ellipseGreen : ellipseRed;

  return (
    <div className="flex flex-col items-center w-full px-2 sm:px-4 md:px-6 relative pt-12">
      <div
        className="absolute top-0 flex flex-col text-[#1567A7] text-center font-roboto items-center transition-all duration-300"
        style={{ 
          left: `${constrainedCmpLeft}%`,
          transform: 'translateX(-50%)'
        }}
      >
        <span className="text-[0.5rem] sm:text-xs md:text-sm transition-all duration-300">
          CMP
        </span>
        <span className="text-[0.625rem] sm:text-sm md:text-base font-bold transition-all duration-300">
          {currentPrice}
        </span>
        <img
          src={cmpTicker}
          className="mt-[0.12rem] md:mt-[0.2rem] w-2.5 sm:w-3 md:w-4 lg:w-5 transition-all duration-300"
          alt="Current Market Price Indicator"
        />
      </div>
      
      {/* Slider container with padding to accommodate circles */}
      <div className="relative w-full px-4">
        <div className="relative w-full h-[5px] sm:h-[6px] md:h-[8px] lg:h-[11px] bg-[#d9d9d9] rounded-lg my-2 sm:my-3 md:my-4 lg:my-5">
        {/* Stop Loss/Target - Left (highest z-index) */}
        <img
          src={leftIcon}
          className="absolute left-0 top-1/2 -translate-x-[40%] -translate-y-1/2 z-30 w-[14px] h-[14px] sm:w-[18px] sm:h-[18px] md:w-[24px] md:h-[24px] lg:w-[30px] lg:h-[30px]"
          alt={leftLabel}
        />
        
        {/* Stop Loss/Target - Right (highest z-index) */}
        <img
          src={rightIcon}
          className="absolute right-0 top-1/2 translate-x-[40%] -translate-y-1/2 z-30 w-[14px] h-[14px] sm:w-[18px] sm:h-[18px] md:w-[24px] md:h-[24px] lg:w-[30px] lg:h-[30px]"
          alt={rightLabel}
        />
        
       
        <div
          className="absolute h-full rounded-[5px] z-0"
          style={{
            left: `${pnlBar.leftPos}%`,
            right: `${pnlBar.rightPos}%`,
            backgroundColor: pnlBar.barColor,
          }}
        ></div>
        
       
        <img
          src={entryIndicatorColor}
          className="absolute top-1/2 -translate-y-1/2 z-20 w-[14px] h-[14px] sm:w-[16px] sm:h-[16px] md:w-[20px] md:h-[20px] lg:w-[26px] lg:h-[26px]"
          style={{
            left: `${adjustedLeftPercentage}%`,
            transform: 'translate(-50%, -50%)',
          }}
          alt="Entry Lower"
        />
        
        
        <img
          src={entryIndicatorColor}
          className="absolute top-1/2 -translate-y-1/2 z-20 w-[14px] h-[14px] sm:w-[16px] sm:h-[16px] md:w-[20px] md:h-[20px] lg:w-[26px] lg:h-[26px]"
          style={{
            right: `${adjustedRightPercentage}%`,
            transform: 'translate(50%, -50%)',
          }}
          alt="Entry Upper"
        />
      </div>
      </div>

      
      <div className="hidden lg:flex justify-between w-full text-center mt-1 sm:mt-2">
     
        <div className="flex flex-col items-start w-1/4">
          <strong className="text-gray-400 font-roboto text-[0.6rem] md:text-sm font-normal whitespace-nowrap">
            {leftLabel}
          </strong>
          <span className="text-[#454545] font-roboto text-[0.7rem] md:text-base font-bold">
            {min}
          </span>
        </div>

        
        <div className="flex flex-col items-center justify-center flex-1">
          <strong className="text-gray-400 font-roboto text-[0.6rem] md:text-sm font-normal whitespace-nowrap">
            Entry Price Range
          </strong>
          <span className="text-[#454545] font-roboto text-[0.7rem] md:text-base font-bold whitespace-nowrap px-1">
            {start} - {end}
          </span>
        </div>

       
        <div className="flex flex-col items-end w-1/4">
          <strong className="text-gray-400 font-roboto text-[0.6rem] md:text-sm font-normal whitespace-nowrap">
            {rightLabel}
          </strong>
          <span className="text-[#454545] font-roboto text-[0.7rem] md:text-base font-bold">
            {max}
          </span>
        </div>
      </div>

      
      <div className="flex lg:hidden flex-col w-full gap-2 mt-2">
        <div className="flex justify-between w-full">
       
          <div className="flex flex-col items-start">
            <strong className="text-gray-400 font-roboto text-[0.55rem] sm:text-xs md:text-sm font-normal whitespace-nowrap">
              {leftLabel}
            </strong>
            <span className="text-[#454545] font-roboto text-[0.65rem] sm:text-sm md:text-base font-bold">
              {min}
            </span>
          </div>
          
        
          <div className="flex flex-col items-end">
            <strong className="text-gray-400 font-roboto text-[0.55rem] sm:text-xs md:text-sm font-normal whitespace-nowrap">
              {rightLabel}
            </strong>
            <span className="text-[#454545] font-roboto text-[0.65rem] sm:text-sm md:text-base font-bold">
              {max}
            </span>
          </div>
        </div>
        
       
        <div className="flex flex-col items-center w-full">
          <strong className="text-gray-400 font-roboto text-[0.55rem] sm:text-xs md:text-sm font-normal whitespace-nowrap">
             Entry Price Range
          </strong>
          <span className="text-[#454545] font-roboto text-[0.65rem] sm:text-sm md:text-base font-bold whitespace-nowrap">
            {start} - {end}
          </span>
        </div>
      </div>
    </div>
  );
};

export default SummarySlider;